import React from 'react'
import { useStateValue } from '../state'
import {
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
} from 'react-bootstrap'

const NewPaymentFormInputs = () => {
  const [currentState, dispatch] = useStateValue()
  return (
    <React.Fragment>
      <FormGroup>
        <ControlLabel>Description</ControlLabel>
        <FormControl
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentDescription',
              newPaymentDescription: e.target.value,
            })
          }
          value={currentState.newPaymentDescription}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Amount</ControlLabel>
        <FormControl
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentAmount',
              newPaymentAmount: e.target.value,
            })
          }
          value={currentState.newPaymentAmount}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel>Stripe Transaction ID</ControlLabel>
        <FormControl
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentTransactionID',
              newPaymentTransactionID: e.target.value,
            })
          }
          value={currentState.newPaymentTransactionID}
        />
        <HelpBlock>
          If this was a credit card transaction run via Stripe, enter the Stripe
          Transaction ID here.
        </HelpBlock>
      </FormGroup>
      <FormGroup>
        <ControlLabel>Source</ControlLabel>
        <FormControl
          componentClass="select"
          onChange={e =>
            dispatch({ type: 'updateNewSource', newSource: e.target.value })
          }
          value={currentState.newSource}
        >
          <option value="">Select Option</option>
          <option value="ACH">ACH</option>
          <option value="Credit Card">Credit Card</option>
          <option value="Check">Check</option>
          <option value="Paypal">Paypal</option>
          <option value="Wire">Wire</option>
          <option value="Other">Other</option>
        </FormControl>
        <HelpBlock>Optional</HelpBlock>
      </FormGroup>
      <FormGroup>
        <ControlLabel>Invoice Number</ControlLabel>
        <FormControl
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewInvoiceNumber',
              newInvoiceNumber: e.target.value,
            })
          }
          value={currentState.newInvoiceNumber}
        />
        <HelpBlock>Optional</HelpBlock>
      </FormGroup>
      <FormGroup>
        <ControlLabel>Course Number</ControlLabel>
        <FormControl
          type="text"
          onChange={e =>
            dispatch({
              type: 'updateNewPaymentCoursenum',
              newPaymentCoursenum: e.target.value,
            })
          }
          value={currentState.newPaymentCoursenum}
        />
      </FormGroup>
    </React.Fragment>
  )
}

export default NewPaymentFormInputs
